import React from "react";

const FormButton = (props) => {
  const { className, type, disabled, onClick, buttonText } = props;

  return (
    <button
      className={className}
      type={type}
      disabled={disabled}
      onClick={() => onClick()}
    >
      {buttonText}
    </button>
  );
};

export default FormButton;
